import type { GetTeacherResponse } from "@/openapi/generated";

const matchSearch = (teacher: GetTeacherResponse, searchValue: string) => {
  if (!searchValue.trim()) return true;

  const q = searchValue.toLowerCase().trim();
  const first = (teacher.firstName ?? "").toLowerCase();
  const last = (teacher.lastName ?? "").toLowerCase();
  const preferred = (teacher.preferredName ?? "").toLowerCase();
  const full = `${first} ${last}`.trim();

  return (
    first.includes(q) ||
    last.includes(q) ||
    preferred.includes(q) ||
    full.includes(q)
  );
};

const matchLocation = (teacher: GetTeacherResponse, location: string | null) => {
  if (!location) return true;
  return (teacher.workLocations ?? []).some((loc) => loc.name === location);
};

export type PublicTeachersFilterInput = {
  search: string;
  location: string | null;
};

export function filterPublicTeachers(
  teachers: GetTeacherResponse[] | undefined,
  filters: PublicTeachersFilterInput,
): GetTeacherResponse[] {
  if (!teachers) return [];

  return teachers.filter(
    (teacher) =>
      matchSearch(teacher, filters.search) &&
      matchLocation(teacher, filters.location),
  );
}
